import { ru } from './ru.js';
export const SUPPORTED_LOCALES = ['ru'];
export const DEFAULT_LOCALE = 'ru';
/**
 * Новые языки добавляются сюда; тип `Dictionary` гарантирует, что словарь
 * заполнен целиком — недостающий ключ становится ошибкой компиляции.
 */
export const dictionaries = { ru };
export function resolveLocale(input) {
    const normalized = input?.slice(0, 2).toLowerCase();
    return SUPPORTED_LOCALES.find((locale) => locale === normalized) ?? DEFAULT_LOCALE;
}
export function getDictionary(locale) {
    return dictionaries[resolveLocale(locale)];
}
/** Подстановка `{name}` в строку словаря. */
export function interpolate(template, params) {
    if (!params) {
        return template;
    }
    return template.replace(/\{(\w+)\}/g, (match, key) => {
        const value = params[key];
        return value === undefined ? match : String(value);
    });
}
export { ru };
/**
 * Длительность в человеческом виде: «45 с», «1 мин.», «1 мин. 15 с».
 *
 * Секунды без пересчёта читаются тем хуже, чем дольше идёт поиск: «75 с»
 * требует деления в уме, а на второй минуте ожидания это уже раздражает.
 * Минуты не заменяют секунды, а дополняют их: счётчик продолжает идти, и
 * видно, что поиск жив.
 */
export function formatDuration(totalSeconds, dictionary) {
    const total = Math.max(0, Math.floor(totalSeconds));
    const minutes = Math.floor(total / 60);
    const seconds = total % 60;
    const { minutesShort, secondsShort } = dictionary.common;
    if (minutes === 0) {
        return `${seconds} ${secondsShort}`;
    }
    if (seconds === 0) {
        return `${minutes} ${minutesShort}`;
    }
    return `${minutes} ${minutesShort} ${seconds} ${secondsShort}`;
}
/**
 * Прозвище собеседника по идентификатору участника диалога.
 *
 * Вычисляется, а не хранится: идентификатор у каждого диалога свой, поэтому имя
 * получается новым при каждой встрече и одинаковым у обеих сторон, переживая
 * переподключение. Между диалогами оно ничего не выдаёт — по нему нельзя узнать
 * человека, с которым уже общался, и это ровно то, ради чего сервис затевался.
 *
 * Две независимые свёртки вместо одной: деление одного числа на длину первого
 * списка связало бы выбор существительного с прилагательным, и часть сочетаний
 * не встречалась бы никогда.
 */
function fold(value, seed) {
    let hash = seed;
    for (let index = 0; index < value.length; index += 1) {
        hash ^= value.charCodeAt(index);
        // Множитель FNV-1a; Math.imul держит вычисление в 32 битах.
        hash = Math.imul(hash, 16_777_619);
    }
    return Math.abs(hash);
}
export function generateNickname(seed, dictionary) {
    const { adjectives, nouns } = dictionary.nicknames;
    const adjective = adjectives[fold(seed, 2_166_136_261) % adjectives.length];
    const noun = nouns[fold(seed, 1_099_511_628) % nouns.length];
    return `${adjective} ${noun}`;
}
//# sourceMappingURL=index.js.map